// extracted by mini-css-extract-plugin
export default {"dropzone":"TabSeiModale_dropzone__h0Pi0","activeDropzone":"TabSeiModale_activeDropzone__qTLQ0","dialog":"TabSeiModale_dialog__jQWnW"};